<template>
  <div class="Bar11Charts">
    <div style="flex-wrap: wrap;
  flex-direction: column;
  display: flex;
  row-gap: 8px;
  ">
      <div class="o_21_item" :style="{}">
        <div class="o_21_item_value" :style="{
          fontSize: `${fontStyle.xAxisSize}px`,
          color: `${fontStyle.xAxisColor}`,
        }">
          {{ dataSet.source[0] ? dataSet.source[0].x || '' : '' }}
        </div>
        <div id="progress-bar-container" class="progress-container">
          <div v-for="(item, index) in colors.item1" :key="item" class="progress-block"
            :style="{ background: item, opacity: setOpactity(index, 'item1') ? 1 : 0.2 }"></div>
          <span :style="{
            fontSize: `${fontStyle.yAxisSize}px`,
            color: `${fontStyle.yAxisColor}`,
          }">{{ dataSet.source[0] ? dataSet.source[0].y || '' : '' }}</span>
        </div>
      </div>

      <div class="o_21_item" :style="{}">
        <div class="o_21_item_value" :style="{
          fontSize: `${fontStyle.xAxisSize}px`,
          color: `${fontStyle.xAxisColor}`,
        }">
          {{ dataSet.source[1] ? dataSet.source[1].x || '' : '' }}
        </div>
        <div id="progress-bar-container" class="progress-container">
          <div v-for="(item, index) in 40" :key="item" class="progress-block" :style="{
            background: getColor('item2', 16, index),
            opacity: setOpactity(index, 'item2') ? 1 : 0.2,
          }"></div>
          <span :style="{
            fontSize: `${fontStyle.yAxisSize}px`,
            color: `${fontStyle.yAxisColor}`,
          }">{{ dataSet.source[1] ? dataSet.source[1].y || '' : '' }}</span>
        </div>
      </div>

      <div class="o_21_item" :style="{}">
        <div class="o_21_item_value" :style="{
          fontSize: `${fontStyle.xAxisSize}px`,
          color: `${fontStyle.xAxisColor}`,
        }">
          {{ dataSet.source[2] ? dataSet.source[2].x || '' : '' }}
        </div>
        <div id="progress-bar-container" class="progress-container">
          <div v-for="(item, index) in 40" :key="item" class="progress-block" :style="{
            background: getColor('item3', 30, index),
            opacity: setOpactity(index, 'item3') ? 1 : 0.2,
          }"></div>
          <span :style="{
            fontSize: `${fontStyle.yAxisSize}px`,
            color: `${fontStyle.yAxisColor}`,
          }">{{ dataSet.source[2] ? dataSet.source[2].y || '' : '' }}
          </span>
        </div>
      </div>

      <div class="o_21_item" :style="{}">
        <div class="o_21_item_value" :style="{
          fontSize: `${fontStyle.xAxisSize}px`,
          color: `${fontStyle.xAxisColor}`,
        }">
          {{ dataSet.source[3] ? dataSet.source[3].x || '' : '' }}
        </div>
        <div id="progress-bar-container" class="progress-container">
          <div v-for="(item, index) in 40" :key="item" class="progress-block" :style="{
            background: getColor('item4', 30, index),
            opacity: setOpactity(index, 'item4') ? 1 : 0.2,
          }"></div>
          <span :style="{
            fontSize: `${fontStyle.yAxisSize}px`,
            color: `${fontStyle.yAxisColor}`,
          }">{{ dataSet.source[3] ? dataSet.source[3].y || '' : '' }}</span>
        </div>
      </div>

      <div class="o_21_item" :style="{}">
        <div class="o_21_item_value" :style="{
          fontSize: `${fontStyle.xAxisSize}px`,
          color: `${fontStyle.xAxisColor}`,
        }">
          {{ dataSet.source[4] ? dataSet.source[4].x || '' : '' }}
        </div>
        <div id="progress-bar-container" class="progress-container">
          <div v-for="(item, index) in 40" :key="item" class="progress-block" :style="{
            background: getColor('item5', 30, index),
            opacity: setOpactity(index, 'item5') ? 1 : 0.2,
          }"></div>
          <span :style="{
            fontSize: `${fontStyle.yAxisSize}px`,
            color: `${fontStyle.yAxisColor}`,
          }">{{ dataSet.source[4] ? dataSet.source[4].y || '' : '' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../../../../common/request';
export default {
  name: 'Bar11Charts',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
    ComboBoxCharts: Object,
  },
  computed: {
    //
  },
  data() {
    return {
      debounce_subscribeConfigurationChange: null, // 订阅Configuration变化的防抖函数
      apiIntervalTaskID: null, // api任务的定时器ID
      staticIntervalTaskID: null, // 静态任务的定时器ID

      noData: false, // 是否没有数据
      fontStyle: {},
      dataSet: {
        seriesList: [],
        source: [],
      },
      colors: {
        item1: [
          '#00abbf',
          '#00acc1',
          '#00aec2',
          '#00afc4',
          '#00b1c6',
          '#00b2c7',
          '#00b4c9',
          '#00b5ca',
          '#00b7cc',
          '#00b8ce',
          '#00bacf',
          '#00bbd1',
          '#00bdd3',
          '#00bed4',
          '#00bfd6',
          '#00c1d8',
          '#00c2d9',
          '#00c4db',
          '#00c5dd',
          '#00c7de',
          '#00c8e0',
          '#00cae1',
          '#00cbe3',
          '#00cde5',
          '#00cee6',
          '#00d0e8',
          '#00d1ea',
          '#00d2eb',
          '#00d4ed',
          '#00d5ef',
          '#00d7f0',
          '#00d8f2',
          '#00daf4',
          '#00dbf5',
          '#00ddf7',
          '#00def8',
          '#00e0fa',
          '#00e1fc',
          '#00e3fd',
          '#00e4ff',
        ],
      },
      maxValue: '',
    };
  },
  created() {
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.startApiIntervalTask();
    this.startStaticIntervalTask();
  },
  methods: {
    getColor(str, Percentage, index) {
      let ind = Percentage / 100;
      let value = ((100 - Percentage) / 100 / 40).toFixed(2);
      if (str === 'item2') {
        return 'rgba(0, 255, 202,' + (value * index + ind) + ')';
      } else if (str === 'item3') {
        return 'rgba(0, 116, 255,' + (value * index + ind) + ')';
      } else if (str === 'item4') {
        return 'rgba(253, 189, 0,' + (value * index + ind) + ')';
      } else if (str === 'item5') {
        return 'rgba(255, 131, 87,' + (value * index + ind) + ')';
      }
    },
    setOpactity(i, str) {
      // === 用户输入参数 ===
      const totalBlocks = 40;
      let currentValue = '';
      if (str === 'item1') {
        currentValue = this.dataSet.source[0] ? this.dataSet.source[0].y : 0;
      } else if (str === 'item2') {
        currentValue = this.dataSet.source[1] ? this.dataSet.source[1].y : 0;
      } else if (str === 'item3') {
        currentValue = this.dataSet.source[2] ? this.dataSet.source[2].y : 0;
      } else if (str === 'item4') {
        currentValue = this.dataSet.source[3] ? this.dataSet.source[3].y : 0;
      } else if (str === 'item5') {
        currentValue = this.dataSet.source[4] ? this.dataSet.source[4].y : 0;
      }
      // === 计算进度比例 ===
      const percent = Math.min(1, Math.max(0, currentValue / this.maxValue)); // 限制在 [0, 1]
      const completedCount = Math.round(totalBlocks * percent); // 已完成的块数

      if (i < completedCount) {
        return true;
      } else {
        return false;
      }
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearTimeout(this.apiIntervalTaskID);
      clearTimeout(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },

    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除之前的 interval 任务（如果有的话）
      clearTimeout(this.apiIntervalTaskID);

      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      console.log('startApiIntervalTask:>>>>', ChartsData?.apiData?.isUseInterval);

      if (ChartsData?.currenEntry !== 'apiData') return;

      this.getApiDataResByFilterAndResponseQuery()
        .then(this.setEchartsOptions)
        .catch(err =>
          console.log('startApiIntervalTask-getApiDataResByFilterAndResponseQuery failed:>>>>', err),
        )
        .finally(() => {
          if (ChartsData?.apiData?.isUseInterval) {
            console.log('开启 interval 任务，间隔请求');
            this.apiIntervalTaskID = setTimeout(
              () => this.startApiIntervalTask(),
              ChartsData?.apiData?.apiInterval * 1000,
            );
          }
        });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;

      if (ChartsData?.currenEntry !== 'staticData') return;

      if (chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let data = this.$_.cloneDeep(ChartsData.staticData);
        data.source.forEach(item => (item.y = 0));
        this.setEchartsOptions(data);
        setTimeout(() => this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData)), 0);

        this.staticIntervalTaskID = setTimeout(
          () => this.startStaticIntervalTask(),
          chartsAnimation?.staticRefreshIntervalTime * 1000,
        );
      } else {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');

        this.getApiDataRes()
          .then(res => {

            // query数据
            let keys = ChartsData.apiData.apiResponseQuery.split('.');
            if (keys.length) {
              console.log('keys:>>>>', keys);
              keys.forEach(key => (res = res[key]));
            }
            // ['data']
            let result = null;

            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              result = this.run_script(ChartsData.apiData.apiFilter, res);
            } else {
              result = res;
            }

            resolve(result);
          })
          .catch(reject);
      });
    },
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;

      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');

        let param = {
          method: ChartsData.apiData.apiUrlMethod,
          url: ChartsData.apiData.apiUrl,
          params: {},
        };

        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');
          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          param['headers'] = { userkey: user_key };
        }

        request(param)
          .then(resolve)
          .catch(reject);
      });
    },

    setEchartsOptions(data = null) {
      this.fontStyle = {};
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.fontStyle.value) {
        this.fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      if (this.Configuration.propertyData?.BarMaxValue?.value) {
        this.maxValue = this.Configuration.propertyData.BarMaxValue.value;
      }

      if (!data) return (this.noData = true);
      this.dataSet = data;

    },

    /**
     * 运行脚本
     * @param {string} script 脚本
     * @param {*} data 数据
     */
    run_script(script, data) {
      let dataSet = {};
      try {
        eval(script);
      } catch (error) {
        console.error('run_script failed: ', error);
      }
      return dataSet;
    },
  },
  beforeUnmount() {
    clearTimeout(this.apiIntervalTaskID);
    clearTimeout(this.staticIntervalTaskID);
    this.unRegisterDebounceAndThrottle();
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  Configuration: {
    componentTitle: '横向方型柱状图',
    componentName: 'Bar11Charts',
    componentOverViewImg: './img/charts/BarCharts/Bar11Charts.png',
    id: '',
    style: {
      width: 462,
      height: 194,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
            // 可以使用data访问api请求的响应结果
            //图表使用的数据类型如下  最大值在右侧进行配置
            dataSet.seriesList =[]
            /*dataSet.source = [
              {
                x: '景区景点客流统计',
                y: 1000,
              }
            ] */

          `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: [],
            source: [
              {
                x: '景区景点客流统计',
                y: 100,
              },
              {
                x: '图书馆客流统计',
                y: 10,
              },
              {
                x: '热门商圈客流统计',
                y: 200,
              },
              {
                x: '餐饮名宿客流统计',
                y: 22,
              },
              {
                x: '酒店住宿客流统计',
                y: 22,
              }
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 14,
          xAxisColor: '#fff',
          yAxisSize: 14,
          yAxisColor: '#fff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      // textComponentUnits: {
      //   propertyComponentName: 'MapTextConfiger',
      //   value: '元',
      // },
      BarMaxValue: {
        propertyComponentName: 'BarMaxValue',
        value: 1000,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.Bar11Charts {
  display: flex;

  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 9px;

  .o_21_item {
    display: flex;
    flex-direction: column;
    row-gap: 0.3vw;
    margin-top: 5px;

    .o_21_item_value {
      margin-bottom: 2px;
    }
  }

  .progress-container {
    display: flex;
    align-items: center;
    column-gap: 3px;

    /* 每个小块间距 */
    span {
      margin-left: 2px;
    }
  }

  .progress-block {
    width: 0.15vw;
    height: 16px;
    transition: background-color 0.3s ease, opacity 0.3s ease;
  }
}
</style>
